import {
  Drawer,
  SimpleToolbar,
  Loader,
  TextField,
  Toast,
} from "../../../components";
import {
  Grid,
  Container,
  makeStyles,
  Typography,
  Box,
  Divider,
  Button,
  IconButton,
  Paper,
} from "@material-ui/core";
import { useDrawer } from "../../../hooks";
import { AuthContext } from "../../../context";
import { useContext, useMemo, useState } from "react";
import { Add, DeleteOutlineRounded } from "@material-ui/icons";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { laboratoryServices } from "../../../services";
import { useForm } from "react-hook-form";

export default function CreateZoneScreen() {
  const { authState, signOut } = useContext(AuthContext);
  const { isOpen, setIsOpen } = useDrawer();
  const [fields, setFields] = useState([{ id: Date.now(), value: "" }]);
  const { register, handleSubmit, errors } = useForm();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const classes = useStyles();
  const history = useHistory();
  const handleAddUnit = () =>
    setFields((prev) => [...prev, { id: Date.now(), value: "" }]);

  const handleDeleteUnit = (id) =>
    setFields((prev) => prev.filter((item) => item.id !== id));
  const handleChange = (id, value) => {
    setFields((prev) =>
      prev.map((field) => (field.id === id ? { ...field, value } : field))
    );
  };

  const addVisitingZone = async (e) => {
    const zones = fields.map((field) => ({ name: field.value }));
    try {
      setLoading(true);
      const { status, response } = await laboratoryServices.addVisitingZones({
        visitingZonesInfo: zones,
        laboratoryId: authState.user.laboratory._id,
        token: authState.token,
      });
      setToast(true);
      setToastMessage(
        status !== 200 ? response.message : "Zona agregada correctamente"
      );
      if (status === 200) {
        setTimeout(() => {
          history.replace("/zones");
        }, 500);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };
  const toRender = useMemo(() => {
    const totalUnits = fields.length;
    return fields.map((field, index) => (
      <>
        <Field
          label="Nombre de zona"
          placeholder="Zona..."
          id={field.id}
          key={field.id}
          onChange={(e) => handleChange(field.id, e.target.value)}
          onDelete={handleDeleteUnit}
          onAdd={handleAddUnit}
          hasAddButton={index === totalUnits - 1}
          hasDeleteButton={totalUnits !== 1}
          name={`zone-${field.id}`}
          inputRef={register({
            required: "Nombre de zona requerido",
          })}
          error={errors[`zone-${field.id}`] ? true : false}
          helperText={
            errors[`zone-${field.id}`] ? errors[`zone-${field.id}`].message : ""
          }
        />
        <Divider
          orientation="horizontal"
          style={{ margin: "1rem 0" }}
          key={`divider-${field._id}`}
        />
      </>
    ));
  }, [fields, errors]);

  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container className={classes.root}>
        {loading && <Loader loading={true} />}
        <Toast
          open={toast}
          message={toastMessage}
          close={() => setToast(false)}
        />
        <Grid item xs={12} className={classes.content}>
          <Container maxWidth={false}>
            <SimpleToolbar
              hideExport={authState.user.laboratory}
              isOpen={isOpen}
              setIsOpen={(value) => setIsOpen(value)}
              noSearchBar
            />
          </Container>

          <Container
            maxWidth={"md"}
            component={"main"}
            className={classes.container_main}
          >
            <Paper className={classes.custom_paper}>
              <Box
                component="form"
                className={classes.form}
                onSubmit={handleSubmit(addVisitingZone)}
              >
                <Box className={classes.container_fields}>{toRender}</Box>
                <Button
                  className={classes.submit_button}
                  color="primary"
                  variant="contained"
                  type="submit"
                  style={{ textTransform: "none" }}
                >
                  Guardar
                </Button>
              </Box>
            </Paper>
          </Container>
        </Grid>
      </Grid>
    </>
  );
}

function Field(props) {
  const {
    id,
    label,
    placeholder,
    hasDeleteButton,
    hasAddButton,
    onDelete,
    onAdd,
    error,
    ...rest
  } = props;
  const cls = fieldStyles({ hasDeleteButton, error })();
  return (
    <Box className={cls.container_field}>
      <Typography
        htmlFor={`input-${id}`}
        component="label"
        variant="body2"
        color="textPrimary"
      >
        {label}{" "}
      </Typography>
      <Box className={cls.field}>
        <TextField
          id={`input-${id}`}
          style={{ with: "100%" }}
          placeholder={placeholder}
          error={error}
          {...rest}
        />
        {hasDeleteButton ? (
          <IconButton onClick={() => onDelete(id)} data-action="delete">
            <DeleteOutlineRounded />
          </IconButton>
        ) : null}
        {hasAddButton ? (
          <IconButton onClick={onAdd}>
            <Add />
          </IconButton>
        ) : null}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: 16,
    paddingBottom: 16,
    flex: 1,
    minHeight: "100vh",
  },
  content: {
    display: "flex",
    flexDirection: "column",
  },
  container_main: {
    display: "flex",
    flexDirection: "column",
    marginTop: theme.spacing(2),
    height: "100%",
  },
  custom_paper: {
    padding: theme.spacing(3),
    [theme.breakpoints.only("xs")]: {
      padding: theme.spacing(1),
    },
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    overflow: "hidden",
    justifyContent: "space-between",
  },
  container_fields: {
    maxHeight: "55vh",
    overflowY: "auto",
    [theme.breakpoints.only("xs")]: {
      maxHeight: "65vh",
    },
  },
  submit_button: {
    boxShadow: `0 0 0 18px ${theme.palette.background.paper}`,
  },
}));

const fieldStyles = ({ hasDeleteButton, error }) =>
  makeStyles((theme) => ({
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    container_field: {
      display: "flex",
      flexDirection: "column",
      gap: 5,
      width: "100%",
    },
    field: {
      display: "flex",
      alignItems: "stretch",
      position: "relative",
      height: 43,
      "& .MuiInput-root": {
        ...(hasDeleteButton && {
          borderRight: "none",
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }),
        height: "100% !important",
        boxSizing: "border-box",
        fontSize: "0.8rem",
        "&.Mui-focused": {
          outlineOffset: `-1px `,
          outline: `1px solid ${theme.palette.warning.dark}`,
          border: "none",
        },
      },
      "& input::placeholder": {
        color: theme.palette.grey[600],
      },
      '& button[data-action="delete"]': {
        borderRadius: 0,
        padding: 0,
        borderWidth: "1pt",
        borderStyle: "solid",
        borderColor: error ? theme.palette.error.main : theme.palette.grey[500],
        borderTopRightRadius: "25px",
        borderBottomRightRadius: "25px",
        aspectRatio: 1,
        height: "100%",
        borderLeft: "none !important",
      },
    },
  }));
